import { render, staticRenderFns } from "./stationery.vue?vue&type=template&id=c0af993a&scoped=true"
import script from "./stationery.vue?vue&type=script&lang=js"
export * from "./stationery.vue?vue&type=script&lang=js"
import style0 from "./stationery.vue?vue&type=style&index=0&id=c0af993a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0af993a",
  null
  
)

export default component.exports